import { Flex, Box, Text, Table, Tbody, Tr, Td, Image, Spacer, Slider } from '@chakra-ui/react';
import React, { useEffect, useState, useLayoutEffect, useReducer } from 'react';
import moment from "moment";
import { displayMillion_ThoudandValues, formatDate_Do_MMM_YYYY, isValidNumber } from '../../auth';
import TypingLoader from "../../components/typing-loader";

import useLoader  from "../../components/loader/loaderstates";
import Loader  from "../../components/loader/loader";
import { getDob, getusername, getgender } from "../../auth";


import { PrimaryButton, Toaster,PrimaryButtonIcon } from "../../components";

function LabTableView({ TableData, onClick, onclickfunc, withModal = false , showUpgradePlanModal , clickDisabled = false}) {
  const [shouldRender, setShouldRender] = useState(false);
  const boxesPerRow = 10;
  const {isLoading, showLoader, dismissLoader } = useLoader();
  const [date, setDate] = useState("");
  const [header, setHeader] = useState("");
  const [normalResultText, setNormalResultText] = useState("");
  const [abnormalResultText, setAbnormalResultText] = useState("");
  const [interpretitionText, setInterpretitionText] = useState("");
  const modalLearnMore = React.useRef();
  const [aiquestion, setAIAnalysis] = useState(null);
  const [aianswers, setAIAnswers] = useState(null);
  const [testname, setTestName] = useState(null);
  const [testresult, setTestResult] = useState(null);
  const [upperbound, setUpperBound] = useState(null);
  const [lowerbound, setlowerBound] = useState(null);
  const [testunit, setTestUnit] = useState(null);
  const [remainingquestions, setRemainingQuestions] = useState('');
  const AiQuestions = React.useRef();
  const AIChatModel = React.useRef();
  const chatContainerRef = React.useRef(null);
  const [meter, setMeter] = useState(50)
  const [remainingTokens, setRemainingTokens] = useState();
  const { showSuccessToast, showErrorToast } = Toaster();

  // Sort values for each row by documentdate descending (latest first)
const sortedTableData = TableData && TableData.rows
  ? {
      ...TableData,
      rows: TableData.rows.map(row => ({
        ...row,
        values: Array.isArray(row.values)
          ? row.values.slice().sort((a, b) => new Date(b.documentdate) - new Date(a.documentdate))
          : []
      }))
    }
  : TableData;
  
  useEffect(() => {
    console.log('Table Data; ', TableData)
  }, [TableData])
  
  // useEffect(() => {
  //   getTokens();
  // }, [])
  var input = {}
//   var getTokens = async () => {
//     try {
//       var result = await FetchTokens(input);
//       if (result) {
//         setRemainingTokens(result)
//       } else {
//         showErrorToast("Something went wrong!")
//       }
//     } catch (error) {
//       console.log(error, "error in fetching account data")
//     }
//     //dismissLoader();
//   }
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShouldRender(true);
    }, 0);
    return () => clearTimeout(timeoutId);
  }, []);

  const onClickFuncInModal = (cellData) => {
    if (cellData) {
      setDate(formatDate_Do_MMM_YYYY(cellData.documentdate))
      setHeader(cellData.header)
      setNormalResultText(cellData.results_interpretation.normal_results)
      setAbnormalResultText(cellData.results_interpretation.abnormal_results)
      setInterpretitionText(cellData.results_interpretation.report_interpretation)
    }
    modalLearnMore.current.openRight()
  }
    let patientgender = getgender();
    let gender = patientgender;
    if (gender === 1) {
      gender = "Female";
    } else if (gender === 2) {
      gender = "Male";
    } else if(gender === 3) {
      gender = "Others";
    }
    // Get Patient details for AI Calls
    const patientname = getusername();
    const dob = getDob();
    const age = calculateAge(dob);
    function calculateAge(dateOfBirth) {
      const today = new Date();
      const dob = new Date(dateOfBirth);
      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();
  
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
      }
      return age;
    }
    let barWidth;
    let triangleWidth;
    let totalSections;
    let sectionWidth;

    let lowerBoundNum;
    let upperBoundNum;
    let actualResultValueNum;

    let lowerThreshold;
    let upperThresholdValue;
    let upperThresholdDup;
    let upperThreshold;
    let trianglePosition;
    let [pointerPos , setPointerPos] = useState(46)

//   const onClickFuncAI = async (data, name, unit) => {
//     console.log(data)
//     setTestName(name);
//     setTestResult(data.resultvalue);
//     setUpperBound(data.upper_bound);
//     setlowerBound(data.lower_bound);

//     // calculatiuon start ------ 
//      barWidth = 86;
//      triangleWidth = 10;
//      totalSections = 5;
//      sectionWidth = barWidth / totalSections;

//      lowerBoundNum = Number(data.lower_bound);
//      upperBoundNum = Number(data.upper_bound);
//      actualResultValueNum = Number(data.resultvalue);

//      lowerThreshold = lowerBoundNum - 0.1 * lowerBoundNum;
//      upperThresholdValue = upperBoundNum + 0.1 * upperBoundNum;
//      upperThresholdDup = upperThresholdValue - upperBoundNum;
//      upperThreshold = upperBoundNum - upperThresholdDup;
//        trianglePosition = barWidth / 2;

//        if (actualResultValueNum < lowerBoundNum && actualResultValueNum < lowerThreshold) {
//         trianglePosition = 14
//       } else if (actualResultValueNum < lowerBoundNum && actualResultValueNum >= lowerThreshold) {
//         trianglePosition = 30
//       } else if (actualResultValueNum >= lowerBoundNum && actualResultValueNum < upperThreshold) {
      
//         trianglePosition = 46
//       } else if (actualResultValueNum >= upperBoundNum) {
//          trianglePosition = 80
//       } else if (actualResultValueNum > lowerBoundNum && actualResultValueNum >= upperThreshold && actualResultValueNum <= upperBoundNum) {
//          trianglePosition = 62
//       } 
//       // else if (actualResultValueNum < upperBoundNum && actualResultValueNum <= upperThreshold) {
     
//       // } 
//       else {
//         trianglePosition = 46;
//       }
//       setPointerPos(trianglePosition)
//      // calculateion end --------

//     setTestUnit(unit)
//   let testlist = []
//    const object = {
//     "test_name": name,
//     "test_unit": unit,
//     "test_value": data.resultvalue,
//     "lower_bound":data.lower_bound,
//     "upper_bound":data.upper_bound,
//    }
//    testlist.push(object)
//    let input = {
//     age: age,
//     name: getusername(),
//     gender: gender,
//     data:{
//       test_data: testlist
//     }
//   };
//   showLoader();
//      const response = await AiAbnormalCall(input);
//      dismissLoader();       
//           console.log(response, "AI Response");
//           if(response?.output?.message == "No credits are available"){
//             showUpgradePlanModal(true)
//           }else if (response) {            
//             setAIAnalysis(response);
//             AiQuestions.current.openRight();
//           }
//   }
//   const GetAIAnswer = async (prompt) => {
//     AIChatModel.current.openRight();
//     getTokens();
//     let AichatInput = {
//       type:"",
//       value: "",
//       unit: "",
//       gender: gender,
//       age: age,
//       name: patientname,
//       prompt: prompt,
//     };

//     // Display question immediately
//     const newQuestion = { question: prompt, answer: "" };
//     setAIAnswers(prevState => {
//       if (prevState === null) {
//         return [newQuestion];
//       } else {
//         return [...prevState, newQuestion];
//       }
//     });
//     //showLoader();
//     const response = await FetchAIAnswer(AichatInput);
//     console.log("AI Reponse", response)
//     //dismissLoader(); 
//     if (response) {
//       // Replace "typing" with actual answer
//       setAIAnswers(prevState => {
//         const updatedAnswers = prevState.map(item => {
//           if (item.question === prompt && item.answer === "") {
//             return { question: item.question, answer: response.answer };
//           }
//           return item;
//         });
//         getTokens();
//         return updatedAnswers;
//       });
//       const indexesToRemove = [];
//       aiquestion.generated_prompts.forEach((question, index) => {
//         if (question.value === prompt) {
//           indexesToRemove.push(index);
//         }
//       });

//       // Remove the objects at the indexes collected above
//       indexesToRemove.reverse().forEach((index) => {
//         aiquestion.generated_prompts.splice(index, 1);
//       });
//       setRemainingQuestions(aiquestion.generated_prompts);
      
//       window.scrollTo(0, document.body.scrollHeight);   
//      }
//      //AIChatModel.current.openRight();
//   };
  const handleSkip = () => {
    AiQuestions.current.closeRight();
  };
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };
    // Use `useLayoutEffect` to ensure the scroll happens after DOM updates
    useLayoutEffect(() => {
      scrollToBottom();
    }, [aianswers]);
    const closeChatModel = ()=>{   
      AIChatModel.current.closeRight();
      AiQuestions.current.closeRight();            
    }
  return (
    <Flex direction="column" overflowX="auto" width="100%">
      <Box maxW="100%" overflowX="auto">
      {isLoading && <Loader/>}
        <Table variant="simple" size="sm" width="100%">
          <Tbody>
            {/* newly added code */}
            {/* {shouldRender && TableData && TableData.rows && TableData.rows.map((row, rowIndex) => ( */}
            {shouldRender && sortedTableData && sortedTableData.rows && sortedTableData.rows.map((row, rowIndex) => (
  <Tr key={row.header}>
    <Td w="210px" h="66px" border="1px solid #E6E7E9">
      <Text fontWeight="bold">{row.header}</Text>
      {row.unit && <Text>({row.unit})</Text>}
    </Td>
    
    {/* Render all values for this vital */}
    {row.values.map((value, index) => (
      <Td w="160px" key={`${row.header}-${index}`} p="24px" border="1px solid #E6E7E9">
        {withModal ? (
          <Box onClick={!clickDisabled ? value.onclickfunc : undefined}
          style={{ cursor: !clickDisabled ? 'pointer' : 'default' }} as={!clickDisabled ? 'button' : undefined}>
            <DelayedRender 
              value={value} 
              delay={rowIndex * 0} 
              clickDisabled={clickDisabled} 
            />
          </Box>
        ) : (
          <Box onClick={!clickDisabled ? value.onclickfunc : undefined} 
          style={{ cursor: !clickDisabled ? 'pointer' : 'default' }} as={!clickDisabled ? 'button' : undefined}>
            <DelayedRender 
              value={value} 
              delay={rowIndex * 0} 
              clickDisabled={clickDisabled} 
            />
          </Box>
        )}
      </Td>
    ))}
    
    {/* Fill remaining empty cells if needed */}
    {Array.from({ length: Math.max(0, boxesPerRow - row.values.length) }, (_, index) => (
      <Td w="160px" key={`empty-${row.header}-${index}`} p="24px" border="1px solid #E6E7E9" />
    ))}
  </Tr>
))}
            {/* existing code */}
            {/* {shouldRender && TableData && TableData.rows && TableData.rows.map((row, rowIndex) => (

              <Tr key={row.header}>
                <Td w="210px" h="66px" border="1px solid #E6E7E9" >
                  <Text fontWeight="bold">{row.header}</Text>
                  {row.unit && <Text>({row.unit})</Text>}
                </Td>
                {row.values.map((value, index) => (
                  <Td w="160px" key={index} p="24px" border="1px solid #E6E7E9"
                  >
                    {withModal == true &&
                      <Box as={!clickDisabled ? 'button' : undefined} 
                    //   onClick={!clickDisabled ? () => onClickFuncInModal(value) : undefined}  
                      >
                        <DelayedRender value={value} delay={rowIndex * 0} clickDisabled={clickDisabled} />
                      </Box>
                    }

                    {withModal == false &&
                     <Box   as={!clickDisabled ? 'button' : undefined} 
                    //  onClick={!clickDisabled ? () => onClickFuncAI(value, row.header, row.unit) : undefined}
                     >
                      <DelayedRender value={value} delay={rowIndex * 0} clickDisabled={clickDisabled} />
                      </Box>
                    }

                  </Td>
                ))}
                {Array.from({ length: boxesPerRow - row.values.length }, (_, index) => (
                  <Td w="160px" key={`empty-${index}`} p="24px" border="1px solid #E6E7E9" />
                ))}
              </Tr>
            ))} */}
          </Tbody>
        </Table>
      </Box>

    </Flex>
  );
}


const DelayedRender = ({ value, delay, clickDisabled }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShouldRender(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [delay]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return moment(dateString).format('Do MMM, YYYY');
  };

  // Robust parsing helper (handles commas and non-numeric like '-')
  const parseNumber = (v) => {
    if (v === null || v === undefined) return NaN;
    const s = String(v).trim();
    if (s === "" || s === "-" || s.toLowerCase() === "none") return NaN;
    // remove commas
    const cleaned = s.replace(/,/g, "");
    return parseFloat(cleaned);
  };

  // Function to determine status and icon (aligns with overview.js behavior)
  const getStatusInfo = () => {
    const resultRaw = value.resultvalue ?? value.actualresultvalue ?? value.preactualresultvalue;
    const upperRaw = value.upper_bound ?? value.upperBound ?? value.upper;
    const lowerRaw = value.lower_bound ?? value.lowerBound ?? value.lower;

    const numericValue = parseNumber(resultRaw);
    const upperBound = parseNumber(upperRaw);
    const lowerBound = parseNumber(lowerRaw);

    // If bounds are valid numbers, use them to decide status
    if (!isNaN(numericValue) && !isNaN(upperBound) && !isNaN(lowerBound)) {
      if (numericValue > upperBound) {
        return { showIcon: true, status: "high", trendColor: "red", icon: "/assets/imgs/red-chart.png", transform: "" };
      }
      if (numericValue < lowerBound) {
        return { showIcon: true, status: "low", trendColor: "red", icon: "/assets/imgs/red-chart.png", transform: "scaleY(-1)" };
      }
      // within range -> show green/normal icon (overview shows check for normal)
      return { showIcon: true, status: "normal", trendColor: "green", icon: "/assets/imgs/check.png", transform: "" };
    }

    // Fallback: respect provided trendcolor if available
    const trend = (value.trendcolor || "").toString().toLowerCase();
    if (trend === "red") {
      return { showIcon: true, status: "abnormal", trendColor: "red", icon: "/assets/imgs/red-chart.png", transform: "" };
    }
    if (trend === "green") {
      return { showIcon: true, status: "normal", trendColor: "green", icon: "/assets/imgs/check.png", transform: "" };
    }

    // No determination possible
    return { showIcon: false };
  };

  const statusInfo = getStatusInfo();

  return shouldRender ? (
    <Box
      display="flex"
      flexDirection="column"
      fontSize="14px"
      fontWeight="500"
      gap="5px"
      w='120px'
      textAlign='center'
      alignItems="center"
      sx={{ textWrap: 'wrap' }}
    >
      {/* Value and Icon Container */}
      <Box display="flex" alignItems="center" justifyContent="center" gap="8px">
        {/* Value with color */}
        <Text style={{ color: statusInfo.trendColor === "red" ? 'red' : 'black' }}>{value.resultvalue}</Text>

        {/* Status Icon */}
        {statusInfo.showIcon && statusInfo.icon && (
          <Box display="flex" alignItems="center" style={{ transform: statusInfo.transform || "" }}>
            <Image w="12px" h="auto" src={statusInfo.icon} alt={statusInfo.status} />
          </Box>
        )}
      </Box>

      {/* Date */}
      <Text 
        sx={{
          textDecoration: !clickDisabled ? "underline" : "none",
          _hover: !clickDisabled
            ? { color: "blue", textDecoration: "underline" }
            : "",
        }}
      >
        {formatDate(value.documentdate)}
      </Text>
    </Box>
  ) : null;
};

// existing
// const DelayedRender = ({ value, delay, clickDisabled }) => {
//   const [shouldRender, setShouldRender] = useState(false);

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       setShouldRender(true);
//     }, delay);

//     return () => clearTimeout(timeoutId);
//   }, [delay]);

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     return moment(dateString).format('Do MMM, YYYY');
//   };

//   // Function to determine status and icon
//   const getStatusInfo = () => {
//     if (!value.upper_bound || !value.lower_bound || !value.resultvalue) {
//       return { showIcon: false };
//     }

//     const numericValue = parseFloat(value.resultvalue);
//     const upperBound = parseFloat(value.upper_bound);
//     const lowerBound = parseFloat(value.lower_bound);

//     if (numericValue > upperBound) {
//       return { 
//         showIcon: true, 
//         status: 'high', 
//         trendColor: value.trendcolor || 'red' 
//       };
//     } else if (numericValue < lowerBound) {
//       return { 
//         showIcon: true, 
//         status: 'low', 
//         trendColor: value.trendcolor || 'red' 
//       };
//     } else {
//       return { showIcon: false };
//     }
//   };

//   const statusInfo = getStatusInfo();

//   return shouldRender ? (
//     <Box
//       display="flex"
//       flexDirection="column"
//       fontSize="14px"
//       fontWeight="500"
//       gap="5px"
//       w='120px'
//       textAlign='center'
//       alignItems="center"
//       sx={{ textWrap: 'wrap' }}
//     >
//       {/* Value and Icon Container */}
//       <Box display="flex" alignItems="center" justifyContent="center" gap="8px">
//         {/* Value with color */}
//         {value.trendcolor === "red" ? (
//           <Text style={{ color: 'red' }}>{value.resultvalue}</Text>
//         ) : (
//           <Text style={{ color: 'black' }}>{value.resultvalue}</Text>
//         )}
        
//         {/* Status Icon */}
//         {statusInfo.showIcon && (
//           statusInfo.status === 'low' && statusInfo.trendColor === 'red' ? (
//             <Box display="flex" alignItems="center" transform="scaleY(-1)">
//               <Image w="12px" h="auto" src="/assets/imgs/red-chart.png" alt="Low" />
//             </Box>
//           ) : statusInfo.status === 'high' && statusInfo.trendColor === 'red' ? (
//             <Box display="flex" alignItems="center">
//               <Image w="12px" h="auto" src="/assets/imgs/red-chart.png" alt="High" />
//             </Box>
//           ) : statusInfo.status === 'low' && statusInfo.trendColor === 'green' ? (
//             <Box display="flex" alignItems="center">
//               <Image w="12px" h="auto" src="/assets/imgs/green-chart.png" alt="Low" />
//             </Box>
//           ) : statusInfo.status === 'high' && statusInfo.trendColor === 'green' ? (
//             <Box display="flex" alignItems="center" transform="scaleY(-1)">
//               <Image w="12px" h="auto" src="/assets/imgs/green-chart.png" alt="High" />
//             </Box>
//           ) : null
//         )}
//       </Box>

//       {/* Date */}
//       <Text 
//         sx={{
//           textDecoration: !clickDisabled ? "underline" : "none",
//           _hover: !clickDisabled
//             ? { color: "blue", textDecoration: "underline" }
//             : "",
//         }}
//       >
//         {formatDate(value.documentdate)}
//       </Text>
//     </Box>
//   ) : null;
// };

export default LabTableView;